<template>
  <span class="status-badge" :class="statusClass">
    <span class="status-dot"></span>
    {{ displayLabel }}
  </span>
</template>

<script>
export default {
  name: 'FeedsStatusBadge',
  props: {
    status: {
      type: String,
      required: true,
      validator: value => ['draft', 'test', 'fix', 'live'].includes(value)
    }
  },
  computed: {
    statusClass() {
      return this.status
    },
    displayLabel() {
      return this.status.charAt(0).toUpperCase() + this.status.slice(1)
    }
  }
}
</script>

<style scoped>
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.status-badge.live {
  background: linear-gradient(135deg, #00857a 0%, #00a896 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(0, 133, 122, 0.3);
}

.status-badge.draft {
  background: linear-gradient(135deg, #ffc233 0%, #ffdb70 100%);
  color: #92400e;
}

.status-badge.test {
  background: linear-gradient(135deg, #a78bfa 0%, #c4b5fd 100%);
  color: #5b21b6;
}

.status-badge.fix {
  background: linear-gradient(135deg, #60a5fa 0%, #93c5fd 100%);
  color: #1e40af;
}
</style>
